import React from "react"
import { Box, CircularProgress } from "@mui/material"

export const ContentSpinner = () => (
  <Box sx={{ display: "grid", placeItems: "center", py: 6 }}>
    <CircularProgress size={30} />
  </Box>
)
